export const ToCurrencyString = (number) => {
    return parseFloat(number).toLocaleString(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export const ToCurrencyStringWithDecimals = (number, decimalDigits = 2, onlyApplyToValueLessThanOne = false) => {
    const fNumber = parseFloat(number);
    if (onlyApplyToValueLessThanOne) {
        if (fNumber < 1) {
            return fNumber.toLocaleString(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: decimalDigits });
        }
        else {
            return fNumber.toLocaleString(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }
    }
    else {
        return fNumber.toLocaleString(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: decimalDigits });
    }
    //return parseFloat(number).toLocaleString(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: decimalDigits });
}

export const ToPercentageString = (decimal) => {
    return parseFloat(decimal).toLocaleString(undefined, { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const ToPercentageStringWithDecimals = (decimal, decimals) => {
    return parseFloat(decimal).toLocaleString(undefined, { style: 'percent', minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}